import { render, staticRenderFns } from "./AstrolabeForm.vue?vue&type=template&id=09106aaa&scoped=true"
import script from "./AstrolabeForm.vue?vue&type=script&lang=js"
export * from "./AstrolabeForm.vue?vue&type=script&lang=js"
import style0 from "./AstrolabeForm.vue?vue&type=style&index=0&id=09106aaa&prod&scoped=true&lang=css"
import style1 from "./AstrolabeForm.vue?vue&type=style&index=1&id=09106aaa&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09106aaa",
  null
  
)

export default component.exports